import React, { Component } from 'react';


class Tabs extends Component {
    constructor(props, context) {
        super(props, context);
        let me = this;
        me.state = {
            activeKey: props.defaultActiveKey
        };

    }
    componentWillReceiveProps(props) {
        let me = this;
        let {
            onChange = () => null
        } = me.props;
        if (props.activeKey) {
            if (me.state.activeKey != props.activeKey) {
                me.setState({
                    activeKey: props.activeKey
                }, () => {
                    onChange(me.state.activeKey);
                });
            }
        }
    }
    onTabClick = (activeKey) => {
        let me = this;
        let {
            onChange = () => null
        } = me.props;

        // let { currentTarget } = e;
        // let role = currentTarget.getAttribute('role');
        // if (role == 'tab') {
        //     let activeKey = currentTarget.getAttribute('tabKey');
        // console.log('onTabClick');
        me.setState({
            activeKey
        }, () => {
            // console.log('setStateEnd');
            onChange(activeKey);
        });
        // }
    }
    renderTab(tab, active,index) {
        let type = typeof tab;
        if (type == 'string') {
            return (
                <div dangerouslySetInnerHTML={{ __html: tab }}></div>
            );
        } else if (type == 'function') {
            return tab(active,index);
        } else {
            return tab;
        }
    }
    render() {
        let me = this;
        let {
            children,
            className = ''
        } = me.props;
        let {
            activeKey
        } = me.state;
        let tabs = [];
        let tabPanels = [];
        // console.log('render');
        React.Children.forEach(children, (child) => {
            if (!child || !child.key) {
                return;
            }
            if (!activeKey) {
                activeKey = child.key;
            }
            // console.log(`activeKey:${activeKey}`);
            let props = child.props || {};
            let isActive = activeKey == child.key;
            tabs.push(
                <div role="tab" tabKey={child.key}
                    onClick={me.onTabClick.bind(me, child.key)}
                    onMouseOver={me.onTabClick.bind(me, child.key)}
                    className={`tabs_tab ${isActive ? 'active' : ''}`}
                    key={child.key}
                >
                    {me.renderTab(props.tab, isActive,child.key)}
                    <div className="line"></div>
                </div>
            );

            tabPanels.push(
                <div className="tabs_content" key={child.key} style={{
                    display: isActive ? 'block' : 'none'
                }}>
                    {props.children}
                </div>
            );
        });

        return (
            <div className={`tabs ${className}`}>
                <div className="tabs_nav" >
                    {tabs}
                </div>
                <div className="tabs_body">
                    {tabPanels}
                </div>
            </div>
        );
    }
}

class TabPane extends Component {
    state = {}
    render() {
        return (
            <div className="tabs_panel">

            </div>
        );
    }
}

Tabs.TabPane = TabPane;

export default Tabs;